<template>
    <div class="main-container">
        <div class="testStudent-body testStudent-body-mobile">
            <h2>Выберите действие</h2>
            <div class="body-container">
                <div
                    v-for="(item, index) in getArray"
                    :key="index"
                    class="body-item"
                    @mousemove="item.iconIndex = true"
                    @mouseleave="item.iconIndex = false"
                    :class="{
                        'wrong': item.value && item.correct === false,
                        'correct': item.value && item.correct === true,
                        'disabled': disabledSelected
                    }"
                    @click.prevent="check(item)"
                >

                    <div class="image-choice">
                        <img
                            v-if="item.icon && item.iconGif && $vuetify.breakpoint.name === 'xs'"
                            :src="require(`@/assets/choiceIcons/${item.iconGif}`)"
                        />
                        <img
                            v-if="item.icon && item.iconGif && $vuetify.breakpoint.name !== 'xs'"
                            :src="require(`@/assets/choiceIcons/${ item.iconIndex ? item.iconGif : item.icon}`)"
                        />
                    </div>

                    <div class="checkbox-choice">
                        <v-checkbox
                            hide-details
                            :color="item.value && item.correct === false ? '#EE4040' : '#33A56E'"
                            readonly
                            :disabled="disabledSelected"
                            v-model="item.value"
                            :ripple="false"
                            label=""
                        />
                        <div class="checkbox-choice__text">{{ item.name }}</div>
                    </div>


                    <v-overlay v-if="item.load || loadAll" :value="item.load || loadAll" :opacity="0.25" absolute>
                        <v-progress-circular indeterminate size="34" />
                    </v-overlay>
                </div>
            </div>
        </div>

        <div class="button d-flex justify-end mt-8">
            <v-btn v-if="success" class="btn ml-2" @click.prevent="next">Дальше</v-btn>
        </div>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import inlineSvg from 'vue-inline-svg'

export default {
    components: {
        TimeoutSnackbar,
        inlineSvg
    },
    computed: {
        ...mapGetters({
            getSectionsArray: 'takeDiagnosticTest/getSections',
            getRoute: 'takeDiagnosticTest/getRoute',
            getIndexCurrentStep: 'takeDiagnosticTest/getIndexCurrentStep'
        }),
        getArray() {
            // алгоритм Фишера-Йетса
            let j, temp;
            for(var i = this.getSectionsArray.length - 1; i > 0; i--){
                j = Math.floor(Math.random()*(i + 1));
                temp = this.getSectionsArray[j];
                this.getSectionsArray[j] = this.getSectionsArray[i];
                this.getSectionsArray[i] = temp;
            }

            return this.getSectionsArray;
        }
    },
    data:() => ({
        loadAll: true,
        success: false,
        disabledSelected: false,
        levelAccess: false,
        iconIndex:false,
        snackbar: {
            show: false,
            text: null,
            color: null,
            timeout: -1
        },
        checkLoad: false
    }),
    methods: {
        ...mapActions({
            getSections: 'takeDiagnosticTest/getSections',
            getDiaTestProcessById: 'takeDiagnosticTest/getDiaTestProcessById',
            sendSectionAnswer: 'takeDiagnosticTest/sendSectionAnswer',
            setStepIsSelectedForDiaTestProcess: 'takeDiagnosticTest/setStepIsSelectedForDiaTestProcess'
        }),
        ...mapMutations({
            resetChoice: 'takeDiagnosticTest/resetChoice',
            choiseSelected: 'takeDiagnosticTest/choiseSelected',
            changeCurrentStep: 'takeDiagnosticTest/changeCurrentStep'
        }),
        next() {
            this.$router.replace(`/lkstudents/dia-test/${this.$route.params.id}/${this.getRoute[this.getIndexCurrentStep].route}?diaTestId=${this.$route.query.diaTestId}&gender=${this.$route.query.gender}&age=${this.$route.query.age}`);
        },
        check(item) {
            if(this.disabledSelected || this.success) return
            if((item.value && item.correct) || (item.value && !item.correct)) return;

            this.disabledSelected = true;
            item.load = true;
            item.value = true;

            this.sendSectionAnswer({ answerSectionId: item.sectionId, processId: this.$route.params.id })
                .then((response) => {
                    if(response) {
                        this.setStepIsSelectedForDiaTestProcess(this.$route.params.id);
                        this.success = true;
                    } else {
                        this.snackbar = { text: 'Неверное действие!', color: 'error', timeout: 3000, show: true };
                    }
                    item.load = false
                    this.disabledSelected = false;
                })
        }
    },
    created() {
        this.getSections(this.$route.query.diaTestId);
        this.resetChoice();
        this.getDiaTestProcessById(this.$route.params.id)
            .then((res) => {
                this.changeCurrentStep(res.data.currentStep);
                if(res.data.isStepSelected) {
                    this.loadAll = false;
                    this.$router.replace(`/lkstudents/dia-test/${this.$route.params.id}/${this.getRoute[this.getIndexCurrentStep].route}?diaTestId=${this.$route.query.diaTestId}&gender=${this.$route.query.gender}&age=${this.$route.query.age}`);
                } else {
                    this.choiseSelected(res.data.currentStep);
                    this.loadAll = false;
                }
            })
    }
}
</script>
<style scoped lang="scss">

@media screen and (max-width: 500px) {
    .testStudent-body {
        display: none;
    }
}

@media screen and (min-width: 501px) {
    .testStudent-body-mobile{
        display: none;
    }
}
</style>